import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Image from 'components/Image';
import Button from 'components/Button';
import {
  Container,
  DialogTitle,
} from 'styles/pages/edit-products/editProductDialog';
import {
  AdminItemGroup,
  Item,
  ProductLink,
  ProductImage,
  Description,
  Text,
  Amount,
} from 'styles/pages/browse-catalog/details';

const ShirtlyProductSync = ({ open, setModal, products, saveToBot }) => {
  const handleClose = () => setModal(false);
  const [data, setData] = useState(undefined);

  useEffect(() => {
    if (!data) {
      setData(products);
    }
  }, [products, data]);
  const disabled = !data?.filter((d) => d?.selected)?.length;

  return (
    <Dialog open={open} onClose={handleClose} maxWidth='lg' scroll='paper'>
      <Container>
        <DialogTitle>Sync Products From Shirtly</DialogTitle>
        <DialogContent>
          <AdminItemGroup>
            {data?.map((item, i) => {
              const product = item.Product;

              return (
                <Item
                  style={{
                    border: item?.selected ? '3px dashed green' : 'none',
                  }}
                  key={`productsCatalog${i}`}
                  onClick={() => {
                    setData(
                      data?.map((d, j) => {
                        if (i !== j) {
                          return d;
                        }
                        return {
                          ...d,
                          selected: !d?.selected,
                        };
                      })
                    );
                  }}>
                  <ProductLink>
                    <ProductImage>
                      <Image
                        src={product?.MarketingImagePath}
                        alt={product?.DisplayName}
                      />
                    </ProductImage>
                    <Description>
                      <Text>{product?.DisplayName}</Text>
                      <Amount>
                        from ${item?.Sizes ? item?.Sizes[0]?.ColoredPrice : 0}{' '}
                        USD
                      </Amount>
                    </Description>
                  </ProductLink>
                </Item>
              );
            })}
          </AdminItemGroup>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              let products = data?.filter((p) => p?.selected);
              products = products.map((p) => _.omit(p, 'selected'));
              saveToBot(products);
            }}
            title='Save to BOT'
            disabled={disabled}
            containerStyle={{
              backgroundColor: '#000',
              color: '#fff',
              opacity: disabled ? 0.2 : 1,
            }}
          />
          <Button
            onClick={handleClose}
            title='Cancel'
            containerStyle={{
              backgroundColor: 'red',
              color: '#fff',
            }}
          />
        </DialogActions>
      </Container>
    </Dialog>
  );
};

export default ShirtlyProductSync;
